import axios from "axios";
import { API_BASE_URL } from '../config';

const CertificateServices = async(token, event_id) => {
    try {
        if (!token) {
            throw new Error('No token available');
        }

        const response = await axios.get(`${API_BASE_URL}certificatesEvents/`, {
            params: {
                event_id: event_id,
            },
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        return response.data;
    } catch (error) {
        throw new Error(error);
    }
}

export default CertificateServices;